import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const createProjectRoute: InvariantJiraRoute = {
	name: 'create-project',
	path: '/jira/create-project',
	exact: true,
};
